import { useTranslation } from "react-i18next";
import { List, RadioButton, Text } from "react-native-paper";
import Box from "../Box";
import { CustomListSubheader } from "../CustomListSubheader";

export type CmeTypeOption = {
	id: string;
	title: string;
	subtitle: string;
	icon: string;
};

type Props = {
	types: CmeTypeOption[];
	selectedType: string;
	onSelect: (id: string) => void;
};

export const CMETypeSelector = ({ types, selectedType, onSelect }: Props) => {
	const { t } = useTranslation();
	return (
		<Box>
			<CustomListSubheader>{t("cme.type")}</CustomListSubheader>
			{types.map((type) => (
				<List.Item
					key={type.id}
					title={<Text variant="bodyMedium">{type.title}</Text>}
					description={<Text variant="bodySmall">{type.subtitle}</Text>}
					style={{ paddingHorizontal: 16 }}
					onPress={() => onSelect(type.id)}
					left={() => <List.Icon icon={type.icon} />}
					right={(p) => (
						<List.Icon
							{...p}
							icon={() => (
								<RadioButton.Android
									value={type.id}
									status={selectedType === type.id ? "checked" : "unchecked"}
									onPress={() => onSelect(type.id)}
								/>
							)}
						/>
					)}
				/>
			))}
		</Box>
	);
};
